import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import ProgressBar from "../../components/ProgressBar";
import { IMAGES } from "../../assets";
import { STRINGS } from "../../constants";
import ExitPopup from "../../components/modal/ExitPopup";
import SubmitQuestionList from "./SubmitQuestionList";
import { addQuizCount } from "../../api/user";
import { AuthContext } from "../../context";
import PropTypes from "prop-types";

const QuizQuestion = ({
  quizListItem,
  isSubmit,
  setQuizItem,
  testStart,
  setTestStart,
  setIsSubmit,
}) => {
  QuizQuestion.propTypes = {
    quizListItem: PropTypes.any,
    isSubmit: PropTypes.bool,
    setQuizItem: PropTypes.any,
    testStart: PropTypes.any,
    setTestStart: PropTypes.bool,
    setIsSubmit: PropTypes.bool,
  };

  const { t } = useTranslation();
  const { profile, activeLanguage } = useContext(AuthContext);

  const [questionList, setQuestionList] = useState([]);
  const [sliderPercentage, setSliderPercentage] = useState(0);
  const [exitModal, setExitModal] = useState(false);
  const [exitTest, setExitTest] = useState(false);

  useEffect(() => {
    let list = [];
    [...(quizListItem?.question ?? [])].forEach((e) => {
      list.push({ ...e });
    });
    setQuestionList(list);
  }, [quizListItem]);

  useEffect(() => {
    const total = questionList?.length;

    let answer = 0;
    questionList.forEach((e) => {
      if (e.selectedAnswer && Array.isArray(e.selectedAnswer)) {
        answer = e.selectedAnswer.length > 0 ? answer + 1 : answer;
      } else if (e.selectedAnswer) {
        answer = answer + 1;
      }
    });

    const percentage = (answer * 100) / total;
    setSliderPercentage(percentage);
  }, [questionList]);

  const submitQuizHandler = async () => {
    try {
      await addQuizCount(quizListItem?._id, profile?._id);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      {questionList?.length > 0 ? (
        <>
          <div className="flex items-center gap-2">
            <button
              className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
              onClick={() => {
                if (isSubmit) {
                  setExitTest(true);
                } else {
                  setQuizItem(null);
                  setQuestionList([]);
                }
              }}
            >
              <img
                className="w-full h-full"
                alt="backarrow"
                src={IMAGES?.backIcon}
              />
            </button>
            <h2 className="questionList text-base font-medium">
              {quizListItem?.quizName}
            </h2>
          </div>
          {isSubmit ? (
            <SubmitQuestionList
              questionList={questionList}
              quizListItem={quizListItem}
            />
          ) : (
            <>
              <div className="my-3">
                <ProgressBar percentage={sliderPercentage} color="#480D9B" />
              </div>
              <div className="h-96 overflow-y-scroll my-2">
                {questionList?.map((item, index) => {
                  return (
                    <div
                      className="p-3 rounded-xl bg-[#FDFDFD] mt-2"
                      key={item?._id}
                    >
                      <h2>{`${
                        activeLanguage === "Marathi"
                          ? new Intl.NumberFormat("mr", {
                              maximumSignificantDigits: 2,
                            }).format(index + 1)
                          : index + 1
                      }. ${item?.question}`}</h2>
                      <div>
                        {item?.option?.map((e, indexO) => {
                          return (
                            <button
                              className="flex items-center justify-between w-full"
                              key={e}
                              onClick={() => {
                                if (
                                  item?.questionType?.pattern ==
                                  "Multiple Choice"
                                ) {
                                  const list = [...questionList];
                                  const question = list[index];
                                  question.selectedAnswer = e;
                                  list.splice(index, 1, question);
                                  setQuestionList(list);
                                } else if (
                                  item?.questionType?.pattern == "Checkbox"
                                ) {
                                  const list = [...questionList];
                                  const question = list[index];
                                  let selectedAnswers =
                                    question?.selectedAnswer ?? [];
                                  if (selectedAnswers?.includes(e)) {
                                    selectedAnswers = selectedAnswers?.filter(
                                      (element) => {
                                        // Issue: The filter function needs to return a value.
                                        // It's missing the return statement.
                                        return element != e;
                                      }
                                    );
                                  } else {
                                    selectedAnswers.push(e);
                                  }
                                  question.selectedAnswer = selectedAnswers;
                                  list.splice(index, 1, question);
                                  setQuestionList(list);
                                }
                              }}
                            >
                              <p
                                className={`${
                                  item?.selectedAnswer == e
                                    ? "text-[#000000]"
                                    : "text-[#8A8A8A]"
                                } text-sm font- my-2 `}
                              >
                                {`${(indexO + 10).toString(36).toUpperCase()}.`}{" "}
                                {e}
                              </p>
                              <div>
                                {item?.questionType?.pattern ==
                                  "Multiple Choice" && (
                                  <img
                                    alt="selectimage"
                                    className="object-contain w-4 h-4"
                                    src={
                                      item?.selectedAnswer == e
                                        ? IMAGES.radioButtonIcon
                                        : IMAGES.roundIcon
                                    }
                                  />
                                )}
                                {item?.questionType?.pattern == "Checkbox" && (
                                  <img
                                    alt="radioicon"
                                    className="object-contain w-4 h-4"
                                    src={
                                      (item?.selectedAnswer ?? []).includes(e)
                                        ? IMAGES.radioCorrectIcon
                                        : IMAGES.roundIcon
                                    }
                                  />
                                )}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex items-center justify-center ">
                <button
                  onClick={() => setExitModal(true)}
                  className="px-4 py-2 rounded-xl border text-sm w-full"
                >
                  {t(STRINGS.submit)}
                </button>
              </div>
            </>
          )}
        </>
      ) : null}

      <ExitPopup
        title={t(STRINGS?.do_you_want_to_submit_quiz)}
        exitModal={exitModal}
        setExitModal={setExitModal}
        testStart={testStart}
        setTestStart={setTestStart}
        onCancel={() => {
          submitQuizHandler();
          setIsSubmit(true);
          setExitModal(false);
          setTestStart(false);
        }}
      />
      {/* Do you want to exit exam  */}
      <ExitPopup
        title={t(STRINGS?.do_you_want_to_quit)}
        exit={t(STRINGS?.quit)}
        exitModal={exitTest}
        setExitModal={setExitTest}
        setTestStart={setTestStart}
        setIsSubmit={setIsSubmit}
        onCancel={() => {
          setQuestionList([]);
          setTestStart(false);
          setExitTest(false);
        }}
      />
    </div>
  );
};

export default QuizQuestion;
